import React from 'react';
import { Card, Button } from 'react-bootstrap';

function QuestionCard(props) {

    function onClickDeleteButton() {
        if (window.confirm(`ต้องการลบคำถามนี้ออกจากระบบใช่หรือไม่?\n\nคำถาม:${props.question}`)) {
            props.onConfirmDeleteButton(props.docId);
        }
    }

    function getBorderColor() {
        return props.isEditing ? '#ffd500' : '#aaa';
    }

    const labels = [ "ก", "ข", "ค", "ง", "จ", "ฉ", "ช", "ซ" ];
    return (
        <Card className='mt-2' style={{ border: `1px solid ${getBorderColor()}` }}>
            <Card.Body>
                <Card.Title>
                    <div style={{ display: 'flex', flex: '1', direction: 'row' }}>
                        <div style={{ display: 'flex', flex: '2', direction: 'row' }}>
                            {props.order + 1}) { props.question }
                        </div>
                        {
                            props.hideActionButtons ?
                                null
                            :
                                <div style={{ display: 'flex', flex: '1', direction: 'row', justifyContent: 'flex-end' }}>
                                    <Button variant='warning' disabled={props.isProcessing} onClick={ (e) => props.onClickEditButton(props.docId) }>Edit</Button>&nbsp;
                                    <Button variant='danger' disabled={props.isProcessing} onClick={ (e) => onClickDeleteButton() }>Delete</Button>&nbsp;
                                    <Button disabled={props.isProcessing} onClick={ (e) => props.onClickUpButton(props.docId) }>Up</Button>&nbsp;
                                    <Button disabled={props.isProcessing} onClick={ (e) => props.onClickDownButton(props.docId) }>Down</Button>
                                </div>
                        }
                    </div>
                </Card.Title>
                <Card.Text>
                    <ul>
                    {
                        props.choices.map((c, i) => {
                            return (
                                <div style={{ display: 'flex', flex: '1', direction: 'row', color: i === props.answer ? 'green' : '#555', fontWeight: i === props.answer ? 'bold' : 'normal' }}>
                                    {
                                        !props.showUserAnswer ?
                                            <div style={{ position: 'relative', display: 'flex', direction: 'row', width: '30px', justifyContent: 'center', border: i === props.answer ? '1px solid green' : '' }}>
                                                {labels[i]}.
                                            </div>
                                        :
                                            props.userAnswer === i ?
                                                <div className='me-2' style={{ display: 'flex', direction: 'row', width: '30px', justifyContent: 'center', backgroundColor: props.userAnswer === props.answer ? 'rgba(0, 255, 0, 0.5)' : 'rgba(255, 0, 0, 0.5)' }}>{labels[i]}.</div>
                                            :
                                                <div className='me-2' style={{ display: 'flex', direction: 'row', width: '30px', justifyContent: 'center' }}>{labels[i]}.</div>
                                    }
                                    <div className='ms-2'>
                                        {c}
                                    </div>
                                </div>
                            );
                        })
                    }
                    </ul>
                </Card.Text>
            </Card.Body>
        </Card>
    );
}

export default QuestionCard;
